"use client";
import Image from 'next/image';
import { StaticImageData } from 'next/image';

interface UseCaseInterface {
  num: string;
  title: string;
  img: StaticImageData | string;
}

export default function UseCase ({ num, title, img }: UseCaseInterface) {
  return (
    <div className='flex flex-col w-[33%] sm:w-full p-[10px] sm:p-0 sm:pt-4'>
      <div className='relative w-full rounded-[10px] overflow-hidden'>
        <div className="absolute bottom-0 left-0 p-[20px] flex flex-col gap-[10px]">
          <p className="h3">{num}</p>
          <h3 className="h3 uppercase">{title}</h3>
        </div>
        <Image
          src={img}
          width={typeof img === 'object' ? img.width : 480}
          height={480}
          className='w-full h-full object-cover rounded-[10px]'
          alt={title}
          onContextMenu={(e) => e.preventDefault()}
        />
      </div>
    </div>
  );
}